import { publicApi } from '../../api/api';

export const getIndicators = async () => {
  const { data } = await publicApi.get('/home-indicators');
  return data;
};
